import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { TranslationKey } from "@/localisation/types";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

type ForbiddenSearch = {
  error: string;
};

export const Route = createFileRoute("/_authenticated/403")({
  component: ForbiddenPage,
  validateSearch: (search: Record<string, unknown>): ForbiddenSearch => {
    return {
      error: (search?.error as string) || "",
    };
  },
});

function ForbiddenPage() {
  const { t } = useTranslation();
  const { error } = Route.useSearch();

  return (
    <div className="flex min-h-screen w-full items-center justify-center px-44">
      <Alert>
        <AlertTitle>{`403 | ${t("http_errors.forbidden.label")}!`}</AlertTitle>
        <AlertDescription>
          {t(error as TranslationKey) as string}
        </AlertDescription>
        <Link
          to="/"
          className="flex items-center gap-2 mt-4 text-sm text-primary hover:underline"
        >
          <ArrowLeft className="w-4 h-4" />
          {t("http_errors.back_to_home")}
        </Link>
      </Alert>
    </div>
  );
}
